import { QueryFactory } from "../../../../Common";
import { SD } from "../../../../Contracts";
export const QGetLeaguesBySportId = QueryFactory(SD.QueryTypes.GetLeaguesBySportId);
//# sourceMappingURL=QGetLeaguesBySportId.js.map